<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Восстановить'" (onOk)="ok()" >
	<p>Вы уверены, что хотите отослать этому пользователю письмо с ссылкой на восстановление пароля?</p>
</base-support-modal>
